import { TextField as MuiTextField } from "@mui/material";
import "./input.css";

const Input = ({
  id,
  name,
  label,
  value,
  onChange,
  error,
  helperText,
  onBlur,
  width,
  height,
  type,
  style,
  disabled = false,
}) => {
  return (
    <MuiTextField
      variant="outlined"
      id={id}
      name={name}
      label={label}
      onChange={onChange}
      value={value}
      error={error}
      helperText={helperText}
      onBlur={onBlur}
      type={type}
      disabled={disabled}
      sx={{
        height: height,
        width: width,
        ...style,
      }}
      // className={name==="contact" ? }
    />
  );
};

export default Input;
